module.exports = __webpack_public_path__ + "files/6df82e44663218e011f03873489c55ce.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Roboto-Slab-regular.ttf
 ** module id = 867
 ** module chunks = 0
 **/